import { render, staticRenderFns } from "./TracingDataDesk.vue?vue&type=template&id=3fd986aa&scoped=true"
import script from "./TracingDataDesk.vue?vue&type=script&lang=js"
export * from "./TracingDataDesk.vue?vue&type=script&lang=js"
import style0 from "./TracingDataDesk.vue?vue&type=style&index=0&id=3fd986aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd986aa",
  null
  
)

export default component.exports